export interface DownloadWorkforceReport {
	department?: number;
	reportDate: Date;
	siteId?: number;
}

export class DownloadWorkforceReport implements DownloadWorkforceReport {
	reportDate = new Date();
	constructor(data?: Partial<DownloadWorkforceReport>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}